export default {"src":"/_next/static/media/secure-disposal.52ae9853.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};